import React, { useState, useContext } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { deleteCookie } from 'helpers';
import {
  Navbar,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
  Collapse,
  NavbarToggler,
  DropdownMenu,
} from 'reactstrap';
import { UserContext } from 'context';

interface Props {
  toggleSidebar?: () => void;
}

export default function MainNavbar({
  toggleSidebar: toggleSidebarExternal,
}: Props) {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('MainNavbar must be used within a UserContext.Provider');
  }
  const { getMatricula, getDoc, is, getNombreApellido } = context;

  const history = useHistory();

  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleProfileMenu = () => setIsProfileMenuOpen(!isProfileMenuOpen);

  const logout = () => {
    // Borramos la cookie
    deleteCookie('accessToken');
    // Quitamos los parámetros que haya en la URL
    history.replace(history.location.pathname);
    // Forzamos la recarga para que se muestra la pantalla de sesión cerrada
    history.go(0);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    if (toggleSidebarExternal) {
      toggleSidebarExternal();
    }
  };

  return (
    <Navbar className="bg-white">
      <a className="navbar-brand d-none d-md-block" href="#"></a>
      <Nav className="d-none d-md-flex" navbar>
        <UncontrolledDropdown nav inNavbar className="">
          <DropdownToggle nav caret style={{ fontSize: '1rem' }}>
            {is(5) ? getMatricula() : getDoc()} - {getNombreApellido()}
          </DropdownToggle>
          <DropdownMenu style={{ right: '10px' }}>
            {is(5) ? (
              <>
                <DropdownItem to="/mi-cuenta" tag={Link}>
                  <i className="ni ni-key-25" />
                  <span>Mi Cuenta</span>
                </DropdownItem>
                <DropdownItem to="/cambiar-contraseña" tag={Link}>
                  <i className="ni ni-key-25" />
                  <span>Cambiar contraseña</span>
                </DropdownItem>
                <DropdownItem divider />
              </>
            ) : null}
            <DropdownItem onClick={logout}>
              <i className="ni ni-user-run" />
              <span>Cerrar sesión</span>
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </Nav>

      <NavbarToggler
        className="d-md-none"
        onClick={toggleSidebar}
        style={{ border: 'none' }}
      >
        {isSidebarOpen ? (
          <i className="fas fa-times" style={{ color: '#66615B' }} />
        ) : (
          <i className="fas fa-bars" style={{ color: '#66615B' }} />
        )}
      </NavbarToggler>
      <NavbarToggler
        className="d-md-none"
        onClick={toggleProfileMenu}
        style={{ border: 'none' }}
      >
        <i className="fas fa-ellipsis-v" style={{ color: '#66615B' }} />
      </NavbarToggler>
      <Collapse isOpen={isProfileMenuOpen} navbar>
        <Nav className="me-auto" navbar>
          <UncontrolledDropdown nav inNavbar>
            <DropdownToggle nav />
            <DropdownItem to="/cambiar-contraseña" tag={Link}>
              <i className="ni ni-key-25" />
              <span>Cambiar contraseña</span>
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem onClick={logout}>
              <i className="ni ni-user-run" />
              <span>Cerrar sesión</span>
            </DropdownItem>
          </UncontrolledDropdown>
        </Nav>
      </Collapse>
    </Navbar>
  );
}
